const customSelectors = {

};
document.addEventListener("DOMContentLoaded", function() {
  gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage':'denied',
      'functionality_storage': 'denied',
      'personalization_storage': 'denied',
      'security_storage': 'denied'
  });
  
  window.Shopify.loadFeatures(
   [{ name: 'consent-tracking-api', version: '0.1' }],
   error => { if (error) {} },
  );
  if (window.Shopify && window.Shopify.customerPrivacy) {
    let defaultConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
    console.log('in',defaultConsent);
    gtag('consent', 'update', {
        'ad_storage': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
        'ad_user_data': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
        'ad_personalization': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
      
        'analytics_storage': defaultConsent.analytics === 'yes' ? 'granted' : 'denied',
        'functionality_storage': defaultConsent.preferences === 'yes' ? 'granted' : 'denied',
        'personalization_storage': defaultConsent.sale_of_data === 'yes' ? 'granted' : 'denied'
    });
    document.addEventListener("visitorConsentCollected", (event) => {
      console.log(event)
      const adStorageGranted = event.detail.firstPartyMarketingAllowed && defaultConsent.thirdPartyMarketingAllowed && event.detail.marketingAllowed;
      gtag('consent', 'update', {
        'ad_storage': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
        'ad_user_data': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
        'ad_personalization': defaultConsent.marketing === 'yes' ? 'granted' : 'denied',
        
        'analytics_storage': event.detail.analyticsAllowed ? 'granted' : 'denied',
        'functionality_storage': event.detail.preferencesAllowed ? 'granted' : 'denied',
        'personalization_storage': event.detail.saleOfDataAllowed ? 'granted' : 'denied'
      });
    });
  }

});
class customJS {
    constructor() {
        this._triggerAddToCart();

        this._removeSearchKeyword();
      
        gsap.registerPlugin(ScrollTrigger)
        // gsap.fromTo(".first-img", {x: 460}, {x: 0, duration:1.5});
        // gsap.fromTo(".second-img", {x: -460}, {x: 0, duration:1.5});


        gsap.matchMedia().add("(min-width: 768px)", () => {
            gsap.from(".first-img", {x: '100%'}, {x: 0, duration:1.5,
                scrollTrigger: {
                    trigger: ".dual-image-with-text",
                    start:"top 75%",
                    end: "bottom 75%",
                    ease: "linear",
                    markers: true
                }
            });

            gsap.from(".second-img", {x: '-100%'}, {x: 0, duration:1.5,
                scrollTrigger: {
                    trigger: ".dual-image-with-text",
                    start:"top 75%",
                    end: "bottom 75%",
                    ease: "linear",
                    markers: true
                }
            });
        });

        gsap.to(".image-with-text-animation", {
            duration: 1.5,
            scrollTrigger: {
                trigger: ".image-with-text-animation",
                start: "top 75%",
                end: "bottom 75%",
                ease: "linear",
                onEnter: function() {
                    document.querySelector(".triangle")?.classList.add("active");
                }
            },
            onStart: function() {
                gsap.fromTo(".dot1", { opacity: 1 }, { opacity: 1, fill: "#93268F", duration: 0.1, ease: "linear" });
                gsap.fromTo(".dot2", { opacity: 0.5 }, { opacity: 1, fill: "#93268F", duration: 0.25, delay: 2.4, ease: "linear" });
                gsap.fromTo(".dot3", { opacity: 0.5 }, { opacity: 1, fill: "#93268F", duration: 0.25, delay: 1.2, ease: "linear" });
            }
        });

        let templateSuffix = document.querySelector('body').getAttribute('data-suffix');
        templateSuffix === 'pickleball-paddles' && this._compareSpecification();
        if(templateSuffix === 'authorized-retailers'){
            window.addEventListener('scroll', this._handleScroll);
            this._scrollsectionActive();
            this._authorizePage();
            this.allowScrollSectionActive = true; 
            var scrollToTopBtn = document.getElementById("scrollToTopBtn");
            scrollToTopBtn.addEventListener("click", () => {
                this._scrollToTop(500); // Adjust the duration as needed
            });
            document.querySelectorAll('[data-country-nav-name]').forEach(el => {
                el.addEventListener('click', (event) => {
                    this.allowScrollSectionActive = false;
                    document.querySelectorAll('[data-scroll-to]').forEach( ele => {
                    ele.classList.remove('active')
                    }) 
                    event.target.closest('li').classList.add('active')
                    setTimeout(() => {
                        this.allowScrollSectionActive = true;
                    }, 1000);
                })
            });
        } 

      let alphaInputs = document.querySelectorAll(".alpha-input");
      alphaInputs.forEach(function(input) {
          input.addEventListener("keypress", function() {
              const char = String.fromCharCode(event.charCode);
              if (!/^[a-zA-Z\s]+$/.test(char)) {
                event.preventDefault(); // Prevent non-alphabetic characters from being entered
              }
          });
      });

        
    }
    _removeSearchKeyword(){
        document.querySelector('[data-remove-search]').addEventListener('click', (event) => {
            event.preventDefault();
            let form = event.target.closest('form');
            form.querySelector('.search__input').value = '';
             event.target.closest('[data-remove-search]').classList.add('d-none')
            let searchEl = event.target.closest('predictive-search');
            searchEl.querySelector('.predictive-search--header')?.classList.remove('show-results');
            if(searchEl.querySelector('#predictive-search-results') != null){
                searchEl.querySelector('#predictive-search-results').innerHTML = '';
            }

        });

        var searchInput = document.querySelector('.search__input');
        var searchInputForm = document.querySelector('.seach-page .search__input');

        searchInput.addEventListener('input', function(event) {
            if (searchInput?.value.trim() !== '') {
                event.target.closest('form').querySelector('[data-remove-search]').classList.remove('d-none')
            } else {
                event.target.closest('form').querySelector('[data-remove-search]').classList.add('d-none')
            }
        });


        // Check if searchInputForm element exists
        if (searchInputForm) {
            // Define the handleSearchInput function
            function handleSearchInput(event) {
                if (searchInputForm.value.trim() !== '') {
                    event.target.closest('form').querySelector('[data-remove-search-form]').classList.remove('d-none');
                } else {
                    event.target.closest('form').querySelector('[data-remove-search-form]').classList.add('d-none');
                }
            }
        
            // Add event listener for 'input' event
            searchInputForm.addEventListener('input', handleSearchInput);
        
            // Add 'load' event listener to call handleSearchInput function when the window is loaded
            window.addEventListener('load', function() {
                handleSearchInput({ target: searchInputForm });
            });

            document.querySelector('[data-remove-search-form]').addEventListener('click', (event) => {
              event.preventDefault();
              let form = event.target.closest('form');
              // event.target.classList.add('d-none')
              form.querySelector('.search__input').value = '';
              let searchCardFound = document.querySelector('#search-product-grid .search-cards');
              if(searchCardFound != null){
                  form.querySelector('.btn-search ').click();
              } 
              
          });
        }

      


    }
    _scrollToTop(duration){
        var start = window.pageYOffset,
        startTime = performance.now();

        const scrollStep = (timestamp) => {
            const currentTime = timestamp || performance.now();
            const progress = currentTime - startTime;

            window.scrollTo(0, this.easeInOutCubic(progress, start, -start, duration));

            if (progress < duration) {
                window.requestAnimationFrame(scrollStep);
            }
        };

        window.requestAnimationFrame(scrollStep);
        
    }
    easeInOutCubic(t, b, c, d) {
        // cubic easing in/out
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t + b;
        t -= 2;
        return c / 2 * (t * t * t + 2) + b;
    }
    _compareSpecification(){
        let compareInputs = document.querySelectorAll('.product-compare-slider [data-compare-input]');
        let checkedInputs = document.querySelectorAll('.product-compare-slider [data-compare-input]:checked');
        let compareBtn = document.querySelector('[data-compare-filter]');
        let resetCompareBtn = document.querySelector('[data-compare-reset]');
        compareInputs.forEach((compareInput) => {
            compareInput.addEventListener('change', () => {
                // Update the checked inputs collection
                checkedInputs = document.querySelectorAll('.product-compare-slider [data-compare-input]:checked');

                // Get the length of checked inputs
                let checkedInputsLength = checkedInputs.length;
                if(checkedInputsLength >= 2){
                    compareBtn.classList.remove('disabled');
                    compareBtn.removeAttribute('disabled')
                } else {
                    compareBtn.classList.add('disabled');
                    compareBtn.setAttribute('disabled', 'disabled')
                }
            });
        });

        compareBtn.addEventListener('click', (event) => {
            event.preventDefault();
            let compareInputs = document.querySelectorAll('.product-compare-slider [data-compare-input]');
            compareInputs.forEach((compareInput) => {
                let swiperSlide = compareInput.closest('.swiper-slide');
                if (!compareInput.checked) {
                    swiperSlide.classList.add('d-none');
                    swiperSlide.classList.remove('slide-visible');
                } else {
                    swiperSlide.classList.remove('d-none');
                    swiperSlide.classList.add('slide-visible');
                }
            });
            productCompareSlider?.update();
           
            event.target.classList.add('disabled');
            event.target.setAttribute('disabled', 'disabled')

            
        });

        resetCompareBtn.addEventListener('click', (event) => {
            event.preventDefault();
            let compareInputs = document.querySelectorAll('.product-compare-slider [data-compare-input]');
            compareInputs.forEach((compareInput) => {
                compareInput.checked = false;
                let swiperSlide = compareInput.closest('.swiper-slide');
                swiperSlide.classList.remove('d-none');
            });
            productCompareSlider?.update();

        });

    }
    _scrollsectionActive(){
    
        document.querySelectorAll('[data-scroll-to]').forEach(ele => {
            ele.classList.remove('active');
        });

       // Scroll-to functionality on click (both touch and click events)
        document.querySelectorAll('[data-scroll-to]').forEach(element => {
            element.addEventListener('click', scrollToElement);
            //element.addEventListener('touchstart', scrollToElement); // Add touch event listener
        });
        
        function scrollToElement(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            
            const sectionId = this.getAttribute('data-scroll-to');
            const targetElement = document.querySelector(`[data-scroll-call="${sectionId}"]`);
        
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                console.error(`Target element with data-scroll-call="${sectionId}" not found.`);
            }
        }
        
        // Highlight navigation items on scroll
        document.addEventListener('scroll', () => {
            document.querySelectorAll('[data-scroll-call]').forEach(ele => {
                const bounding = ele.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        
                // Calculate when the element is at least 50% visible
                const isVisible = (bounding.top >= 0 && bounding.top <= windowHeight * 0.5)
                    || (bounding.bottom >= 0 && bounding.bottom <= windowHeight * 0.5)
                    || (bounding.top < 0 && bounding.bottom > windowHeight);
        
                if (isVisible) {
                    const sectionId = ele.getAttribute('data-scroll-call');
        
                    // Remove 'active' class from all navigation items
                    document.querySelectorAll('.sticky_nav_item.active').forEach(navItem => {
                        navItem.classList.remove('active');
                    });
        
                    // Add 'active' class to the corresponding navigation item
                    const correspondingNavItem = document.querySelector(`[data-scroll-to="${sectionId}"]`);
                    if (correspondingNavItem) {
                        correspondingNavItem.classList.add('active');
                    }
                }
            });
        });    
        
    }
    _triggerAddToCart(){
        let addBtns = document.querySelectorAll('[data-add-btn-trigger]');
        addBtns.forEach((addBtn) => {
            addBtn.addEventListener('click', (event) => {
                event.preventDefault();
                event.target.closest('.shop-btn').classList.add('loading')
                event.target.closest('.card').querySelector('[data-main-add] .shop-btn').click();
                setTimeout(() =>{
                    event.target.closest('.shop-btn').classList.remove('loading')
                },3000);
            });
        });
    }
    _authorizePage(){
        let countrySearchEl = document.querySelector('#countrySearch [data-country-search]');
        countrySearchEl.addEventListener('click', (event) => {
            event.preventDefault();
            let searchTerm = event.target.closest('#countrySearch').querySelector('input').value;
            searchTerm = searchTerm.replace(/\s+/g, '-');

            if(searchTerm.length >= 2){
                let countryList = document.querySelectorAll('.country_list .country_item');
                countryList.forEach(el => {
                    let country = el.getAttribute('data-title');
                    if (country.toLowerCase().includes(searchTerm.toLowerCase())) {
                       el.classList.add('order-first')
                       let container = el.closest('section');
                       container.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        el.classList.remove('order-first')
                    }
                })
            }
           
        });
    }
    _handleScroll(){
        let countryMap = document.querySelector('.authorized-retailer-wrapper .world_map_wrapper');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.querySelector('.authorize-sticky').classList.remove('show');
                } else {
                    document.querySelector('.authorize-sticky').classList.add('show');
                }
            })
        }, {
            rootMargin: '-50px 0px 0px 0px' // Adjust the offset here (top right bottom left)
        });
        
        observer.observe(countryMap);
       
    }
   
   
}

typeof customJS !== 'undefined' && new customJS();

// gsap.registerPlugin(ScrollTrigger)
// // gsap.fromTo(".first-img", {x: 460}, {x: 0, duration:1.5});
// // gsap.fromTo(".second-img", {x: -460}, {x: 0, duration:1.5});


// gsap.matchMedia().add("(min-width: 800px)", () => {
//     gsap.to(".first-img", {x: 460}, {x: 0, duration:1.5,
//         scrollTrigger: {
//             trigger: ".dual-image-with-text",
//             start:"top 75%",
//             end: "bottom 75%",
//             ease: "linear",
//             markers: true
//         }
//     });

//     gsap.to(".second-img", {x: -460}, {x: 0, duration:1.5,
//         scrollTrigger: {
//             trigger: ".dual-image-with-text",
//             start:"top 75%",
//             end: "bottom 75%",
//             ease: "linear",
//             markers: true
//         }
//     });
// });

// gsap.to(".image-with-text-animation", {
//     duration: 1.5,
//     scrollTrigger: {
//         trigger: ".image-with-text-animation",
//         start: "top 75%",
//         end: "bottom 75%",
//         ease: "linear",
//         onEnter: function() {
//             document.querySelector(".triangle")?.classList.add("active");
//         }
//     },
//     onStart: function() {
//         gsap.fromTo(".dot1", { opacity: 1 }, { opacity: 1, fill: "#93268F", duration: 0.1, ease: "linear" });
//         gsap.fromTo(".dot2", { opacity: 0.5 }, { opacity: 1, fill: "#93268F", duration: 0.25, delay: 2.4, ease: "linear" });
//         gsap.fromTo(".dot3", { opacity: 0.5 }, { opacity: 1, fill: "#93268F", duration: 0.25, delay: 1.2, ease: "linear" });
//     }
// });



